// Ethiopian tax year = Hamle 1 → Sene 30, i.e. 8 July → 7 July (Gregorian),
// for both individuals and corporates (per Ethiopian tax administration).
// Boundaries are computed in Addis Ababa local time (UTC+3, no DST) so the
// window is correct no matter what timezone the admin's browser is in.
const ADDIS_OFFSET_MS = 3 * 60 * 60 * 1000;

// Tax year `year` spans [8 Jul year, 7 Jul year+1]. Returned as absolute epoch
// ms bounds (inclusive) ready for a tripdate range query, plus display labels.
export const taxYearBounds = (year) => {
  const fromTs = Date.UTC(year, 6, 8) - ADDIS_OFFSET_MS;           // 8 Jul year, 00:00 Addis
  const toTs = Date.UTC(year + 1, 6, 8) - ADDIS_OFFSET_MS - 1;     // last ms of 7 Jul year+1 Addis
  return {
    year,
    fromTs,
    toTs,
    label: `${year}/${year + 1}`,
    range: `8 Jul ${year} – 7 Jul ${year + 1}`,
  };
};

// The tax year that "now" falls in: before 8 Jul → still the previous year's window.
export const currentTaxYear = () => {
  const now = Date.now();
  const y = new Date(now).getUTCFullYear();
  const thisYearStart = Date.UTC(y, 6, 8) - ADDIS_OFFSET_MS;
  return now < thisYearStart ? y - 1 : y;
};

// Most recent `n` tax years (current first), each as a taxYearBounds object.
export const taxYearOptions = (n = 6) => {
  const current = currentTaxYear();
  const out = [];
  for (let i = 0; i < n; i++) out.push(taxYearBounds(current - i));
  return out;
};
